import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageLayout } from '@/shared/layout/PageLayout';
import { Button } from '@/components/ui';
import { AuthButton } from '@/core/permissions/AuthButton';
import { EditBasicInfo } from './components/EditBasicInfo';
import { EditWorkInfo } from './components/EditWorkInfo';
import { EditEmergencyInfo } from './components/EditEmergencyInfo';
import { EditSkeleton } from './components/EditSkeleton';
import { useUserEdit } from './hooks/useUserEdit';

export function UsersEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const {
    formData,
    isLoading,
    isSaving,
    updateField,
    handleSave
  } = useUserEdit(id);

  return (
    <PageLayout
      title="Chỉnh sửa nhân sự"
      description="Cập nhật thông tin chi tiết của nhân viên."
      breadcrumbs={[{ label: 'Nhân sự', path: '/users' }, { label: 'Chỉnh sửa' }]}
    >
      <div className="max-w-[1200px] mx-auto pb-24">
        {isLoading ? (
          <EditSkeleton />
        ) : (
          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
              <EditBasicInfo formData={formData} updateField={updateField} />
              <EditWorkInfo formData={formData} updateField={updateField} />
            </div>
            
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
              <EditEmergencyInfo formData={formData} updateField={updateField} />
              
              {/* Action Buttons Block */}
              <div className="bg-white rounded-md p-6 border border-slate-100 w-full h-full flex flex-col justify-center">
                <h2 className="sm:text-sm text-xs font-medium text-slate-800 mb-6">Thao tác</h2>
                <div className="flex items-center gap-3">
                  <Button 
                    variant="ghost" 
                    className="text-slate-500 sm:text-sm text-xs h-10 rounded-md flex-1"
                    onClick={() => navigate(-1)}
                  >
                    Hủy bỏ
                  </Button>
                  
                  <AuthButton
                    module="users"
                    action="edit"
                    variant="primary"
                    className="bg-emerald-700 hover:bg-emerald-800 text-white sm:text-sm text-xs h-10 rounded-md flex-1"
                    onClick={handleSave}
                    isLoading={isSaving}
                  >
                    Lưu thay đổi
                  </AuthButton>
                </div>
                <p className="text-[11px] text-slate-400 text-center mt-4">
                  Bằng việc lưu, bạn xác nhận các thông tin trên là chính xác.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
}

export default UsersEditPage;
